import React, { useMemo, useState } from "react";
import Styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

const getRecoveryCodes = (data) => {
    if (Array.isArray(data?.recovery_codes)) return data.recovery_codes;
    if (Array.isArray(data?.response?.recovery_codes)) return data.response.recovery_codes;

    return [];
};

const BackupCodesStep = ({
                             backupCodesData,
                             onBack,
                             onDone,
                         }) => {
    const { t } = useTranslation();

    const [isSaved, setIsSaved] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const recoveryCodes = useMemo(() => {
        return getRecoveryCodes(backupCodesData);
    }, [backupCodesData]);

    const codesText = recoveryCodes.join("\n");

    const copyCodesHandler = async () => {
        if (!codesText) return;

        try {
            await navigator.clipboard.writeText(codesText);

            setIsCopied(true);

            setTimeout(() => {
                setIsCopied(false);
            }, 1600);
        } catch (error) {
            console.error("Copy recovery codes failed:", error);
        }
    };

    const downloadCodesHandler = () => {
        if (!codesText) return;

        const blob = new Blob([codesText], {
            type: "text/plain;charset=utf-8",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = "kairo-2fa-backup-codes.txt";
        link.click();

        URL.revokeObjectURL(url);
    };

    const savedChangeHandler = (event) => {
        setIsSaved(event.target.checked);
    };

    return (
        <div className={Styles.backupStep}>
            <div className={Styles.successNotice}>
                <div className={Styles.successIcon}>
                    <span />
                </div>

                <div className={Styles.successText}>
                    {t("2FA успешно включена")}
                </div>
            </div>

            <div className={Styles.recoveryBox}>
                <div className={Styles.recoveryTitle}>
                    {t("Ваши резервные коды")}
                </div>

                {recoveryCodes.length > 0 ? (
                    <div className={Styles.recoveryCodesGrid}>
                        {recoveryCodes.map((code) => (
                            <div
                                className={Styles.recoveryCodeItem}
                                key={code}
                            >
                                {code}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={Styles.recoveryEmpty}>
                        {t("Резервные коды не найдены")}
                    </div>
                )}

                <div className={Styles.recoveryActions}>
                    <button
                        type="button"
                        className={Styles.copyCodesBtn}
                        onClick={copyCodesHandler}
                        disabled={!recoveryCodes.length}
                    >
                        <span className={Styles.copyCodesIcon}>
                            <span />
                            <span />
                        </span>

                        {isCopied ? t("Скопировано") : t("Скопировать коды")}
                    </button>

                    <button
                        type="button"
                        className={Styles.downloadCodesBtn}
                        onClick={downloadCodesHandler}
                        disabled={!recoveryCodes.length}
                    >
                        {t("Скачать")}
                    </button>
                </div>
            </div>

            <label className={Styles.savedCheckboxLabel}>
                <input
                    type="checkbox"
                    checked={isSaved}
                    onChange={savedChangeHandler}
                />

                <span className={Styles.savedCheckbox} />

                <span className={Styles.savedCheckboxText}>
                    {t("Я сохранил резервные коды")}
                </span>
            </label>

            <div className={Styles.actionsRow}>
                <button
                    type="button"
                    className={Styles.cancelBtn}
                    onClick={onBack}
                >
                    {t("Назад")}
                </button>

                <button
                    type="button"
                    className={Styles.continueBtn}
                    onClick={onDone}
                    disabled={!isSaved}
                >
                    {t("Готово")}
                </button>
            </div>

            <div className={Styles.bottomNote}>
                {t("Вы можете использовать эти коды, если потеряете доступ к приложению-аутентификатору.")}
            </div>
        </div>
    );
};

export default BackupCodesStep;